import React from "react";
import { useTranslation } from "react-i18next";
import SubscriptionInfo from "./SubscriptionInfo";

export default function Subscription() {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded p-4">
      <div className="mb-4 fw-bold fs-4">
        {t("payment.Current Subscription")}
      </div>
      <div className="p-4 rounded border border-light">
        <SubscriptionInfo />
      </div>
    </div>
  );
}
